import type { SpreadTemplate } from "../types";

// English comment: Base spread templates (normalized blocks). Each format file maps these into SpreadTemplate[]
export const BASE_SPREAD_TEMPLATES: Array<{
  idSuffix: string;
  name: string;
  unitKind: "spread";
  blocks: SpreadTemplate["blocks"];
}> = [
  {
    idSuffix: "01_full",
    name: "Full photo",
    unitKind: "spread",
    blocks: [
      { type: "image", anchor: "both", bleed: true, box: { x: 0, y: 0, w: 1, h: 1 } }
    ]
  },
  {
    idSuffix: "02_photo_text",
    name: "Photo + text",
    unitKind: "spread",
    blocks: [
      { type: "image", anchor: "left", box: { x: 0.12, y: 0.14, w: 0.88, h: 0.72 } },
      { type: "text", role: "heading", anchor: "right", box: { x: 0.08, y: 0.14, w: 0.8, h: 0.12 }, text: "Heading" },
      { type: "text", role: "body", anchor: "right", box: { x: 0.08, y: 0.3, w: 0.8, h: 0.56 }, text: "Text..." }
    ]
  },
  {
    idSuffix: "03_3photos",
    name: "3 photos",
    unitKind: "spread",
    blocks: [
      { type: "image", anchor: "left", box: { x: 0.12, y: 0.14, w: 0.84, h: 0.34 } },
      { type: "image", anchor: "right", box: { x: 0.04, y: 0.14, w: 0.84, h: 0.34 } },
      { type: "image", anchor: "both", box: { x: 0.06, y: 0.52, w: 0.88, h: 0.34 } }
    ]
  },
  {
    idSuffix: "04_quote",
    name: "Quote",
    unitKind: "spread",
    blocks: [
      { type: "text", role: "heading", anchor: "both", box: { x: 0.1, y: 0.26, w: 0.8, h: 0.2 }, text: "Big quote" },
      { type: "text", role: "body", anchor: "both", box: { x: 0.2, y: 0.5, w: 0.6, h: 0.25 }, text: "- Author" }
    ]
  },
  {
    idSuffix: "05_two",
    name: "2 photos",
    unitKind: "spread",
    blocks: [
      { type: "image", anchor: "left", box: { x: 0.12, y: 0.18, w: 0.84, h: 0.64 } },
      { type: "image", anchor: "right", box: { x: 0.04, y: 0.18, w: 0.84, h: 0.64 }, maskShapeId: "heart" }
    ]
  },
  {
    idSuffix: "06_banner",
    name: "Banner",
    unitKind: "spread",
    blocks: [
      { type: "shape", shape_id: "rectangle", anchor: "both", box: { x: 0, y: 0, w: 1, h: 0.16 }, fill_hex: "#111827" },
      { type: "text", role: "heading", anchor: "both", box: { x: 0.08, y: 0.03, w: 0.84, h: 0.1 }, text: "Title" },
      { type: "image", anchor: "both", box: { x: 0.06, y: 0.22, w: 0.88, h: 0.7 } }
    ]
  },
  {
    idSuffix: "07_grid4",
    name: "4 photos grid",
    unitKind: "spread",
    blocks: [
      { type: "image", anchor: "left", box: { x: 0.12, y: 0.14, w: 0.84, h: 0.34 } },
      { type: "image", anchor: "right", box: { x: 0.04, y: 0.14, w: 0.84, h: 0.34 } },
      { type: "image", anchor: "left", box: { x: 0.12, y: 0.54, w: 0.84, h: 0.34 } },
      { type: "image", anchor: "right", box: { x: 0.04, y: 0.54, w: 0.84, h: 0.34 } }
    ]
  },
  {
    idSuffix: "08_text",
    name: "Text page",
    unitKind: "spread",
    blocks: [
      { type: "text", role: "heading", anchor: "both", box: { x: 0.08, y: 0.14, w: 0.84, h: 0.12 }, text: "Heading" },
      { type: "text", role: "body", anchor: "both", box: { x: 0.08, y: 0.3, w: 0.84, h: 0.6 }, text: "Long text..." }
    ]
  }
];
